import React from "react";
import { Hyperlink, HyperlinkProps } from "../../../Links/Hyperlink/Hyperlink";
import { NoHrefLink, NoHrefLinkProps } from "../../../Links/NoHrefLink/NoHrefLink";
import { Stack, StackItem } from "../../../Stacks/Stack/Stack";
import { Text } from "../../../Text/Text";
import { ListItemColumnProps } from "../shared/props";

export type FooterColumnLinkProps = NoHrefLinkProps | HyperlinkProps;

export interface FooterColumnProps extends ListItemColumnProps {
    /**
     * Label to display in the list footer.
     */
    readonly label?: string;
    /**
     * Links to display in the list footer.
     */
    readonly links: readonly FooterColumnLinkProps[];
}

export const FooterColumn: React.FC<FooterColumnProps> = ({
    label,
    links,
    disabled
}) => (
    <Stack
        verticalAlign="center"
        wrap={true}
        horizontal={true}
        padding="1px 0 1px 0"
    >
        {label && (
            <Stack
                horizontal={true}
                verticalAlign="center"
                padding="0 16px 0 0"
            >
                <Text variant="bodySecondaryText" disabled={disabled}>
                    {label}
                </Text>
            </Stack>
        )}
        <Stack
            verticalAlign="center"
            horizontal={true}
            wrap={true}
        >
            {links.map((link, index) => (
                // Wrap in padded stackitems because: TwoUI links don't expose padding / margin, and because
                // if we gave the parent stack a `childrenGap`, that would also introduce vertical spacing when
                // the links wrap over multiple lines
                <StackItem padding="0 16px 0 0" key={index}>
                    {"href" in link ?
                        <Hyperlink  {...link} disabled={disabled ?? link.disabled} /> :
                        <NoHrefLink {...link} disabled={disabled ?? link.disabled} />
                    }
                </StackItem>
            ))}
        </Stack>
    </Stack>
);
